 'use client';

 import { useI18n } from '@/shared/providers/I18nProvider';

export function ChatDescription() {
  const { dict } = useI18n();
  return (
    <div className='border-border/50 bg-muted/30 border-b px-4 py-3'>
      <div className='text-muted-foreground text-sm'>
        {dict.chat.description}
      </div>
    </div>
  );
}
